import ButtonShadow from 'components/PhoneBoothScreen/animations/ButtonShadow';
import { ArrowClockwise } from 'phosphor-react';
import React from 'react';
import styled from 'styled-components/macro';

import { Path } from './Path';

const Restart = styled(ArrowClockwise)`
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 50%;
  width: 50%;
  color: #00ffc9;
  transition: transform 0.5s ease;
`;
const Wrapper = styled.div<{ sizeRatio: number }>`
  position: relative;
  width: ${({ sizeRatio }) => `${95 * sizeRatio}px`};
  height: ${({ sizeRatio }) => `${95 * sizeRatio}px`};
  border-radius: 100%;

  animation: ${ButtonShadow} 1.6s infinite;

  &:hover ${Restart} {
    transform: translate(-50%, -50%) rotate(280deg);
  }
`;
const InnerWrapperCircle = styled.div<{ sizeRatio: number }>`
  z-index: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${({ sizeRatio }) => `${22 * sizeRatio}px`};
  height: ${({ sizeRatio }) => `${22 * sizeRatio}px`};
  border: ${({ sizeRatio }) => `${2 * sizeRatio}px solid #00ffc9`};
  border-radius: 100%;
  background-color: #008d76;
`;
const InnerCircle = styled.div<{ sizeRatio: number }>`
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${({ sizeRatio }) => `${14 * sizeRatio}px`};
  height: ${({ sizeRatio }) => `${14 * sizeRatio}px`};
  border: ${({ sizeRatio }) => `${4 * sizeRatio}px solid #00ffc9`};
  border-radius: 100%;
  background-color: #008d76;
`;

const CircularProgressbar = styled.svg`
  vertical-align: middle;
  width: 100%;
  box-shadow: 0px 0px 0px 5px #00ffc9 inset;
  border-radius: 100%;
`;
const ProgressPath = styled(Path)`
  stroke: #00ffc9;
  stroke-linecap: 'butt';
  transition: stroke-dashoffset 1s linear 0s;
`;
const Trail = styled(Path)`
  stroke: transparent;
  stroke-linecap: 'butt';
`;

type ProgressCircleProps = {
  percentage: number;
  sizeRatio: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onReplay?: () => void;
};

const ProgressCircle: React.FC<ProgressCircleProps> = ({
  percentage,
  sizeRatio,
  onReplay,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Wrapper
      sizeRatio={sizeRatio}
      onClick={() => {
        if (percentage <= 0 && onReplay) onReplay();
      }}
      onMouseEnter={() => {
        if (percentage <= 0 && onMouseEnter) onMouseEnter();
      }}
      onMouseLeave={() => {
        if (percentage <= 0 && onMouseLeave) onMouseLeave();
      }}
    >
      <CircularProgressbar viewBox={`0 0 ${100 * sizeRatio} ${100 * sizeRatio}`}>
        <Trail sizeRatio={sizeRatio} counterClockwise={true} dashRatio={1} />
        <ProgressPath sizeRatio={sizeRatio} counterClockwise={true} dashRatio={percentage / 100} />
      </CircularProgressbar>
      {percentage > 0 && (
        <InnerWrapperCircle sizeRatio={sizeRatio}>
          <InnerCircle sizeRatio={sizeRatio} />
        </InnerWrapperCircle>
      )}
      {percentage <= 0 && <Restart weight="bold" />}
    </Wrapper>
  );
};

export default ProgressCircle;
